import * as React from 'react';
import { ProgramBenefitsItem as TProgramBenefitsItem } from '~/common/types/types';
import { ProgramBenefitsItem } from '../components';
import * as styles from './program-benefits-list.module.scss';

type Props = {
  items: TProgramBenefitsItem[];
};

const ProgramBenefitsList: React.FC<Props> = ({ items }) => (
  <ul className={styles.list}>
    {items.map((item) => (
      <ProgramBenefitsItem key={item.title} item={item} />
    ))}
  </ul>
);

export { ProgramBenefitsList };
